import React from 'react';

import {
  OFF_DUTY_PURPOSE,
  PROCEDURE_TERMS_TO_EXCLUDE
} from '@/utils/constants';

import './ProcedurePills.css';

interface ProcedurePillsProps {
  procedures: string[];
}

const ProcedurePills: React.FC<ProcedurePillsProps> = ({ procedures }) => {
  if (!procedures) return null;

  return (
    <div className="procedure-pills">
      {procedures.map((procedure, index) => (
        <span
          key={index}
          className={`procedure-pill ${procedure === OFF_DUTY_PURPOSE ? 'procedure-pill--off-duty' : ''}`}
        >
          {procedure
            .replace(
              new RegExp(
                PROCEDURE_TERMS_TO_EXCLUDE.map((term) =>
                  term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
                ).join('|'),
                'gi'
              ),
              ''
            )
            .replace(/[()]/g, (match: string) => (match === '(' ? '[' : ']'))
            .replace(/\s*\[\s*\]/g, '')
            .trim()}
        </span>
      ))}
    </div>
  );
};

export default ProcedurePills;
